// Reglas de que puede hacer cada rol del panel del cajero (tabla tblmultipagos_roles):
//   1 = Administrador  -> consulta TODO el sistema; nunca cobra ni valida pagos.
//   2 = CajeroPinpad   -> cobra con Pinpad y valida pagos.
//   3 = CajeroTPV      -> no tiene Pinpad; valida pagos (con voucher o TPV).
//
// El servidor es quien hace cumplir estas reglas (responde 403 al Administrador en los
// endpoints de cobro y validacion); estas funciones solo deciden que muestra la pantalla:
//  - "ve..."    = el boton aparece. El Administrador lo ve pero DESHABILITADO, para que pueda
//                 revisar cada modulo sin poder usar las acciones.
//  - "puede..." = el boton esta habilitado.

export const MENSAJE_SOLO_LECTURA = "Solo consulta: el Administrador no puede cobrar ni validar pagos.";

const rolTexto = (rol) => (rol === undefined || rol === null ? "" : String(rol));

// El rol de la sesion actual (se guarda al iniciar sesion en el panel del cajero)
export const rolDeSesion = () => {
  try {
    return rolTexto(localStorage.getItem("cajero_rol"));
  } catch (error) {
    return "";
  }
};

export const esAdministrador = (rol) => rolTexto(rol) === "1";

// Cobrar con Pinpad: solo el cajero con Pinpad. El rol 3 no tiene terminal y no ve el boton.
export const puedeCobrarConPinpad = (rol) => rolTexto(rol) === "2";
export const veCobroConPinpad = (rol) => ["1", "2"].includes(rolTexto(rol));

// Validar pagos (vouchers, complementos): cualquier cajero real. El Administrador solo consulta.
export const puedeValidarPago = (rol) => ["2", "3"].includes(rolTexto(rol));
export const veValidarPago = (rol) => ["1", "2", "3"].includes(rolTexto(rol));
